export class ApplicationIDP {
    appId: any;
    orgId:any
    idp:any;
    name:any;
}

export class IDPSETTING{
    idp_id: string;
    clientId: string;
    clientSecret: string;
    callbackURL: string="http://localhost:3000/single-auth/okta/callback";
    audience: string;
    idp: string;
    issuer: string;
    apiKey: string
    active: boolean;
    scopes:any;
    defaultRole:string
}
export class AD{
    public ldapurl:string;
    public baseDN:string;
    public username:string;
    public password:string;
    public active:string
}
